import { Injectable, Sanitizer } from '@angular/core';
import { CartResource } from '../api/cart.resource.service';
import { OrderResource } from '../api/order.resource.service';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class CartService {

  private cart$: any;
  private products$: any;
  private order$: any;
  private cartText$: string;
  private qrcode$: string;

  constructor(
    private cartResource: CartResource,
    private orderResource: OrderResource,
    private sanatizer: DomSanitizer
  ) { }

  private async refreshCart() {
    this.cart$ = await this.cartResource.getCart();
    this.cartText$ = (await this.cartResource.getCartText({ nmbr: this.cart$.nmbr })).text;
    this.qrcode$ = (await this.cartResource.getQrCode({ nmbr: this.cart$.nmbr }));
    if (this.cart$ && this.cart$.ordernmbr) {
      this.order$ = await this.orderResource.getOne({ nmbr: this.cart$.ordernmbr })
    }
    await this.refreshProducts();
  }

  private async refreshProducts() {
    if (this.cart$) {
      this.products$ = await this.cartResource.getProducts({ nmbr: this.cart$.nmbr, 'producttranslations.language1': localStorage.getItem('prefLanguage') });
    }
  }

  resetCart() {
    this.cart$ = undefined;
    this.products$ = undefined;
    this.order$ = undefined;
  }

  public async reloadCart() {
    await this.refreshCart();
  }

  public async finish() {
    if (this.cart$) {
      await this.cartResource.finish({ nmbr: this.cart$.nmbr });
    }
  }

  public async unfinish() {
    if (this.cart$) {
      await this.cartResource.unfinish({ nmbr: this.cart$.nmbr });
    }
  }

  public get cart(): any {
    if (this.cart$) {
      return this.cart$;
    }
    return {};
  }

  public get state() {
    if (this.cart$) {
      return this.cart$.weborderstate;
    }
  }

  public get nmbr() {
    if (this.cart$) {
      return this.cart$.nmbr;
    }
  }

  public get cartText() {
    return this.cartText$ || '';
  }

  public get qrcode() {
    return this.sanatizer.bypassSecurityTrustHtml(this.qrcode$ || '');
  }

  public get order() {
    if (this.order$) {
      return this.order$;
    }
    return {};
  }

  public get hasCart(): boolean {
    return this.cart$ && this.products$ && this.products$.results && this.products$.results.length > 0;
  }

  public get hasOrder() {
    return this.order$;
  }

  public get products(): any[] {
    if (this.products$) {
      return this.products$.results;
    }
    return [];
  }

  public async addToCart(p) {
    if (!this.cart$) {
      await this.refreshCart();
    }
    p.nmbr = this.cart$.nmbr;
    await this.cartResource.addProduct(p);
    await this.refreshCart();
  }

  public async removeFromCart(p) {
    if (!this.cart$) {
      await this.refreshCart();
    }
    p.nmbr = this.cart$.nmbr;
    await this.cartResource.deleteProduct(p);
    await this.refreshCart();
  }

  public async updateProductInCart(p) {
    if (!this.cart$) {
      await this.refreshCart();
    }
    p.nmbr = this.cart$.nmbr;
    await this.cartResource.updateProduct(p);
    await this.refreshCart();
  }
}
